import React, { useEffect, useRef } from "react";
import Sidebars from "../../Components/Sidebar/sidebar";
import {
  useTheme,
  ThemeProvider,
  Typography,
  useMediaQuery,
  Box,
  Container,
  Grid
} from '@mui/material';
import '../../css/Dashboard.css'
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import { useDispatch, useSelector } from "react-redux";
import appColors from "../../config/appColors";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));   // ← changed to md (most common breakpoint)
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dashboard, setDashboard] = React.useState(null);
  const user = useSelector((state) => state.authReducer.user);

  const getDashboard = async () => {

    const onSuccess = (res) => {
      console.log('res___', res)
      setDashboard(res?.data);
      dispatch(setLoader(false))
    }

    const onError = (err) => {
      console.log('err', err?.data)
      dispatch(setLoader(false))
    }

    dispatch(setLoader(true));
    const body = {
      token: user?.token
    }

    await postRequest(body, apiRoutes.getDashboard, onSuccess, onError)

  }


  useEffect(() => {
    getDashboard();
  }, [])
  return (
    <ThemeProvider theme={theme}>
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        {/* Sidebar - hidden on mobile */}
        <Sidebars />

        <div
          style={{
            flex: 1,
            padding: isMobile ? '16px' : '24px',
            paddingLeft: isMobile ? '16px' : '32px',
            width: '100%',
            boxSizing: 'border-box',
            marginLeft: isMobile ? 0 : 20, // only when sidebar is visible
          }}
        >
          <Typography
            variant={isMobile ? "h5" : "h4"}
            component="h1"
            sx={{ mb: 3, fontWeight: 600,fontFamily:'Poppins' }}
            className={`headertext ${isMobile ? 'small-screen' : ''}`}
          >
            Dashboard
          </Typography>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: isMobile ? 16 : 24,
              justifyContent: isMobile ? 'center' : 'flex-start',
            }}
          >
            {/* Agreements */}
            <div
              onClick={() => navigate('/agreements')}
              style={{
                ...infoContainer,
                cursor: 'pointer',
                flex: isMobile ? '1 1 100%' : '1 1 240px',
                maxWidth: isMobile ? '100%' : 280,
                minWidth: isMobile ? 'auto' : 240,
              }}
            >
              <div style={infoHeadingContainer}>
                <Typography sx={infoHeading}>Agreements</Typography>
              </div>
              <div style={infoValueContainer}>
                <div style={row}>
                  <Typography sx={title}>Active:</Typography>
                  <Typography sx={value}>{dashboard?.total_active_agreements ?? '-'}</Typography>
                </div>
                <div style={row}>
                  <Typography sx={title}>Sign pending:</Typography>
                  <Typography sx={value}>{dashboard?.total_sign_pending_agreements ?? '-'}</Typography>
                </div>
                <div style={row}>
                  <Typography sx={title}>Closed:</Typography>
                  <Typography sx={value}>{dashboard?.total_closed_agreements ?? '-'}</Typography>
                </div>
              </div>
            </div>

            {/* Invoices */}
            <div
              onClick={() => navigate('/invoices')}
              style={{
                ...infoContainer,
                cursor: 'pointer',
                flex: isMobile ? '1 1 100%' : '1 1 300px',
                maxWidth: isMobile ? '100%' : 340,
                minWidth: isMobile ? 'auto' : 280,
              }}
            >
              <div style={infoHeadingContainer}>
                <Typography sx={infoHeading}>Invoices</Typography>
              </div>
              <div style={infoValueContainer}>
                <div style={row}>
                  <Typography sx={{ ...title, width: isMobile ? 'auto' : 230 }}>
                    Total paid (Invoice+Expense) :
                  </Typography>
                  <Typography sx={value}>{dashboard?.total_paid_amounts ?? '-'}</Typography>
                </div>
                <div style={row}>
                  <Typography sx={{ ...title, width: isMobile ? 'auto' : 230 }}>
                    Last week collection (Invoices) :
                  </Typography>
                  <Typography sx={value}>{dashboard?.total_paid_last_week ?? '-'}</Typography>
                </div>
                <div style={row}>
                  <Typography sx={{ ...title, width: isMobile ? 'auto' : 230 }}>
                    Pending:
                  </Typography>
                  <Typography sx={value}>{dashboard?.total_pending_invoices ?? '-'}</Typography>
                </div>
                <div style={row}>
                  <Typography sx={{ ...title, width: isMobile ? 'auto' : 230 }}>
                    Cancelled:
                  </Typography>
                  <Typography sx={value}>{dashboard?.total_cancelled_invoices ?? '-'}</Typography>
                </div>
              </div>
            </div>

            {/* Vehicles */}
            <div
              onClick={() => navigate('/vehicles')}
              style={{
                ...infoContainer,
                cursor: 'pointer',
                flex: isMobile ? '1 1 100%' : '1 1 240px',
                maxWidth: isMobile ? '100%' : 280,
                minWidth: isMobile ? 'auto' : 240,
              }}
            >
              <div style={infoHeadingContainer}>
                <Typography sx={infoHeading}>Vehicles</Typography>
              </div>
              <div style={infoValueContainer}>
                <div style={row}>
                  <Typography sx={title}>Booked:</Typography>
                  <Typography sx={value}>{dashboard?.total_booked_vehicles ?? '-'}</Typography>
                </div>
                <div style={row}>
                  <Typography sx={title}>Available:</Typography>
                  <Typography sx={value}>{dashboard?.total_available_vehicles ?? '-'}</Typography>
                </div>
                <div style={row}>
                  <Typography sx={title}>Upcoming MOTs:</Typography>
                  <Typography sx={value}>{dashboard?.total_vehicles_with_upcoming_or_expired_mots ?? '-'}</Typography>
                </div>
              </div>
            </div>

            {/* Customers */}
            <div
              onClick={() => navigate('/users')}
              style={{
                ...infoContainer,
                cursor: 'pointer',
                flex: isMobile ? '1 1 100%' : '1 1 240px',
                maxWidth: isMobile ? '100%' : 280,
                minWidth: isMobile ? 'auto' : 240,
              }}
            >
              <div style={infoHeadingContainer}>
                <Typography sx={infoHeading}>Customers</Typography>
              </div>
              <div style={infoValueContainer}>
                <div style={row}>
                  <Typography sx={title}>Active:</Typography>
                  <Typography sx={value}>{dashboard?.total_active_customers ?? '-'}</Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

const infoContainer = {
  width: 250,
  borderRadius: 10,
  backgroundColor: appColors.white,
  padding: 5,
  paddingBottom: 20,
  boxSizing: 'border-box',
};

const infoHeadingContainer = {
  width: "100%",
  backgroundColor: appColors.primaryLight,
  borderTopRightRadius: 10,
  borderTopLeftRadius: 10,
  height: 40,
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex'
};

const infoHeading = {
  fontSize: 12,
  color: appColors.white,
  fontFamily: 'Poppins',
  fontWeight: 600
};

const infoValueContainer = {
  display: 'flex',
  justifyContent: 'center',
  width: "100%",
  marginTop: 15,
  flexDirection: 'column'
};

const title = {
  fontSize: 14,
  color: appColors.inputLabel,
  fontFamily: 'Poppins',
  fontWeight: 600,
  width: 120,
};

const value = {
  fontSize: 14,
  color: appColors.inputLabel,
  fontFamily: 'Poppins',
  fontWeight: 500,
};

const row = {
  display: 'flex',
  flexDirection: 'row',
  marginLeft: 10,
  marginBottom: 6,
};
export default Dashboard;